import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import HeadingBanner from "../HeadingBanner";
import LeftPanel from "../LeftPanel";
import "./ClassroomHandoverShell.css";

function ClassroomHandoverPageShell({ identity, children }) {
  return (
    <Container fluid className="vh-100 classroom-handover-page" data-testid="classroom-handover-page-shell">
      <HeadingBanner
        name={identity?.name ? `Welcome ${identity.name}!` : "Classroom setup"}
        isLoggedIn
        cloud
        teacherid={identity?.id}
        schoolid={identity?.schoolid}
      />
      <Row className="h-100">
        <LeftPanel className="handover-shell-navigation" />
        <Col sm={{ span: 10, offset: 2 }} className="blue-background handover-shell-content">
          {children}
        </Col>
      </Row>
    </Container>
  );
}

export default ClassroomHandoverPageShell;
